import $ from 'jquery'

export class TimingCircle {

  constructor () {
    this.$container = $('.timing-circle')

    if (this.$container.length === 0) return

    this.$main = $('.timing-circle-container')
    this.$window = $(window)

    this.$window.on('scroll', this.handleScroll.bind(this))

    this.handleScroll()
  }

  handleScroll () {
    this.percent = this.$window.scrollTop() * 100 / (this.$main.scrollTop() + this.$main.outerHeight(true))
    this.percent = parseInt(this.percent)

    if (isNaN(this.percent)) {
      this.percent = 100
    }
    if (this.percent < 0) {
      this.percent = 0
    }
    if (this.percent > 100) {
      this.percent = 100
    }

    this.$container.each(this.design.bind(this))
  }

  design (index, item) {
    let $item = $(item)

    $item.find('.timing-circle-circle').css('stroke-dasharray', this.percent + ', 100')
  }

}
